import { CustomColumn } from '../../../components/Tables/record/RecordTable';

export const dteInvalidationLogColumns: CustomColumn<any>[] = [
  {
    Header: 'Categoría',
    accessor: 'documentCategory',
  },
  {
    Header: 'Tipo DTE',
    accessor: 'documentType',
  },
  {
    Header: 'Código Generación',
    accessor: 'generationCode',
  },
  {
    Header: 'Ambiente',
    accessor: 'ambiente',
  },
  {
    Header: 'HTTP',
    accessor: 'httpStatus',
  },
  {
    Header: 'Fecha',
    accessor: 'createdAtFormatted',
  },
];
